class StockListController {

    constructor($scope, $state, availabilityModelService, messageService, access, time) {
        this.$scope = $scope;
        this.$state = $state;
        this.availabilityModelService = availabilityModelService;
        this.messageService = messageService;
        this.access = access;
        this.time = time;
    }

    $onInit () {
        this.sort_date = false;

        this.updatePaging();
        this.$scope.$watch(
            function (scope) {
                return scope.current_page;
            },
            function (newVal, oldVal, scope) {
                if (newVal && newVal !== oldVal) {
                    scope.$ctrl.stock = undefined;
                    if (scope.$ctrl.filtertext && scope.$ctrl.filtertype && scope.$ctrl.isFiltered) {
                        let filter = {};
                        filter[scope.$ctrl.filtertype] = scope.$ctrl.filtertext;
                        filter.page = newVal;
                        filter.perpage = scope.$ctrl.per_page;

                        filter = scope.$ctrl.sortFilter(filter);

                        scope.$ctrl.availabilityModelService.searchStock(filter).then(response => {
                            scope.$ctrl.stock = response;
                            scope.$ctrl.loading = false;
                        });
                    }
                    else {
                        let filter = {};
                        filter.page = newVal;
                        filter.perpage = scope.per_page;

                        filter = scope.$ctrl.sortFilter(filter);

                        scope.$ctrl.availabilityModelService.getStock(filter)
                            .then(list => scope.$ctrl.stock = list);
                    }
                }
            }
        );
    }

    updatePaging () {
        this.$scope.per_page = this.stock.per_page;
        this.$scope.current_page = this.stock.current_page;
        this.$scope.total = this.stock.total;
    }

    filter () {
        if (!this.loading) {
            let filter = {};
            if (this.filtertype) {
                let filtertext = this.filtertext;
                if (this.filtertype === 'date') {
                    if (this.filtertext) {
                        filtertext = filtertext.format('YYYY-MM-DD');
                    }
                }
                filter[this.filtertype] = filtertext;
            }
            filter.page = this.$scope.page;
            filter.perpage = this.$scope.per_page;

            filter = this.sortFilter(filter);

            this.startFilter();
            this.availabilityModelService.searchStock(filter).then(response => {
                this.isFiltered = true;
                this.endFilter(response);
            });
        }
    }

    clearfilter () {
        if (this.isFiltered) {
            this.startFilter();
            this.sort_date = false;
            this.sort_end = false;
            this.availabilityModelService.getStock().then(response => {
                this.isFiltered = false;
                this.endFilter(response);
            });
        }
    }

    filtertypeChange () {
        switch (this.filtertype) {
            default:
                this.filtertext = '';
                break;
            case 'event_type':
                this.filtertext = 'spaday';
                break;
            case 'date':
                this.filtertext = undefined;
                break;
        }
    }

    startFilter () {
        this.stock = undefined;
        this.loading = true;
    }

    endFilter (response) {
        this.stock = response;
        this.updatePaging();
        this.loading = false;
    }

    sort (type) {
        switch (type) {
            case 'date':
                if (!this.sort_date || this.sort_date === 'asc') {
                    this.sort_date = 'desc';
                } else {
                    this.sort_date = 'asc';
                }
                break;
        }

        this.filter();
    }

    sortFilter (filter) {
        if (this.sort_date) {
            filter.order_by = 'date';
            filter.direction = this.sort_date;
        }
        return filter;
    }
}

StockListController.$inject = ['$scope', '$state', 'availabilityModelService', 'messageService', 'access', 'time'];

export default StockListController;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/availability/controllers/stock.list.controller.js